// extracted by mini-css-extract-plugin
export default {"ui_kit_tags":"tags_ui_kit_tags__+xqWJ","ui_kit_tags_item":"tags_ui_kit_tags_item__6N1J-"};